import axios from '../../config/axiosConfig';
import { GET_FIN_YEARS, FIN_YEAR_REQUEST, FIN_YEAR_FAILURE, CREATE_FIN_YEAR, UPDATE_FIN_YEAR, DELETE_FIN_YEAR } from '../types';

export const getFinYears = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: FIN_YEAR_REQUEST });
            return axios.get('/finyear/getAll').then((response) => {
                if (response.data) {
                    dispatch({ type: GET_FIN_YEARS, payload: response.data });
                } else {
                    dispatch({ type: FIN_YEAR_FAILURE, error: 'Get finyears data failed.' });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
            });            
        } catch (error) {
            console.error(error);
            dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
        }
    };
};

export const createFinYear = (finyear) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: FIN_YEAR_REQUEST });
            return axios.post("/finyear/add", finyear, { params: { userId: auth.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_FIN_YEAR, payload: response.data });
                } else {
                    dispatch({
                        type: FIN_YEAR_FAILURE,
                        error: "FinYear create failed.",
                    });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateFinYear = (id, data) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: FIN_YEAR_REQUEST });
            const { auth } = getState();
            return axios.put("/finyear/update", { id, data }, { params: { userId: auth.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({
                        type: UPDATE_FIN_YEAR,
                        payload: { id, data: response.data },
                    });
                } else {
                    dispatch({
                        type: FIN_YEAR_FAILURE,
                        error: "FinYear update failed.",
                    });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteFinYear = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: FIN_YEAR_REQUEST });
            return axios.delete(`/finyear/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_FIN_YEAR, id: id });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FIN_YEAR_FAILURE, error: error.message });
            throw error;
        }
    };
};
